/* eslint-disable @typescript-eslint/no-unused-vars */

import { trackPromise } from 'react-promise-tracker';
import { MisValesAhorroMockProvider } from './MisValesAhorroMockProvider';
import { MocksHelper } from './MocksHelper';
import api from '../../api/api';

const valesProvider = new MisValesAhorroMockProvider();
const MisValesAhorroMockService = {
  retrieveValesAhorro: (input: any) => {
    const data = valesProvider.getValesResponse();
    return Promise.resolve(MocksHelper.getAxiosResponse(data));
  },

  activarVale: (input: object) => {
    valesProvider.setActivado(input);
    const data = {
      error: false,
      pojos: null,
    };
    return Promise.resolve(MocksHelper.getAxiosResponse(data));
  },
  getValesPreferencia: () => {
    const data = valesProvider.getPreferenciaResponse();
    return Promise.resolve(MocksHelper.getAxiosResponse(data));
  },
  updateValesPreferencia: (input: object) => {
    const data = {
      codRespuesta: '200',
    };
    return Promise.resolve(MocksHelper.getAxiosResponse(data));
  },
};
export default MisValesAhorroMockService;
